import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { LocationFacade } from '@app/modules/location/facade/location.facade';
import { onContentPaneChange } from './../../location.animations';
import { DetailsSubcontext, ViewContext } from '@app/store/layout/reducers/layout.reducer';
import { ViewableAsset } from '@app/modules/location/models/viewable-asset.model';
import { ResourceLoadState } from '@app/store/filters/models/resource-load.state';
import { LoadingAnimationService } from '@app/services/loading-animation.service';
import { tap, takeUntil } from 'rxjs/operators';
@Component({
  selector: 'app-desktop-location-container',
  templateUrl: './desktop-location-container.component.html',
  styleUrls: ['./desktop-location-container.component.scss'],
  animations: [onContentPaneChange],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DesktopLocationContainerComponent implements OnInit, OnDestroy {
  @Output()
  handleOpenFilterDialog: EventEmitter<any> = new EventEmitter<any>();
  @Output()
  handleSidenavOpenedChange: EventEmitter<boolean> = new EventEmitter<boolean>();

  public selectedAsset: Observable<ViewableAsset>;
  public assetLoadState = this.locationFacade.getAssetsLoadState();
  public companiesLoadState = this.locationFacade.getCompaniesLoadState();
  public recentPathLoadState = this.locationFacade.getRecentPathLoadState();
  liveValue = DetailsSubcontext.LIVE;
  historyValue = DetailsSubcontext.HISTORY;
  views = ViewContext;
  loading = true;
  onDestroy$ = new Subject<void>();

  constructor(
    public locationFacade: LocationFacade,
    public loadingAnimationService: LoadingAnimationService,
    private changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getAreAssetsLoading();
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }

  loadingInProgress(companiesLoadState, assetsLoadState, recentPathLoadState) {
    const okCompanies =
      companiesLoadState === ResourceLoadState.INITIAL || companiesLoadState === ResourceLoadState.LOADING;

    const okAssets = assetsLoadState === ResourceLoadState.LOADING;
    const okRecentPath = recentPathLoadState === ResourceLoadState.LOADING;
    return okCompanies || okAssets || okRecentPath;
  }

  getAreAssetsLoading() {
    if (this.loadingAnimationService.shouldShowAssetsLoadingAnimations) {
      this.locationFacade
        .getAssetsLoadState()
        .pipe(
          tap(loadState => {
            this.loading = loadState === ResourceLoadState.LOADING;
            this.changeDetectorRef.detectChanges();
          }),
          takeUntil(this.onDestroy$)
        )
        .subscribe();
    } else {
      this.loading = false;
    }
  }
}
